define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var LocationModel = /** @class */ (function () {
        function LocationModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.CustomerName = ko.observable();
            this.LocationType = ko.observable();
            this.ServerId = ko.observable();
            this.OldServerId = ko.observable();
            this.Dns = ko.observable('');
            this.OldDns = ko.observable('');
            this.DnsDomain = ko.observable('');
            this.DnsName = ko.observable('');
            this.OldDnsName = ko.observable('');
            this.Address = ko.observable('');
            this.Comment = ko.observable('');
            this.RouterDetails = ko.observable('');
            this.ServerDetails = ko.observable('');
            this.IspDetails = ko.observable('');
            this.GeneralNotes = ko.observable('');
            this.UpdateDns = ko.observable(false);
            this.IpAddress = ko.observable('');
            this.UserPassword = ko.observable('');
            this.DynDnsUsername = ko.observable('');
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, LocationModel.Mapping, self);
            }
        }
        LocationModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new LocationModel(options.data);
            }
        };
        return LocationModel;
    }());
    return LocationModel;
});
//# sourceMappingURL=LocationModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/LocationModel.js
// module id = 197
// module chunks = 2